import CardProject from '../../components/items/CardProject'

import pokedex from '../../img/projects/pokedex.jpg'
import html from '../../img/technology/html.png'
import css from '../../img/technology/css.png'
import javaScript from '../../img/technology/javascript.png'

export default function Project5() {
  return (
    <div>
      <CardProject
        name="Pokedex"
        img={pokedex}
        text="A PokéDex é um projeto dedicado aos apaixonados pelo mundo dos Pokémon, desenvolvido utilizando HTML, CSS e JavaScript. Oferecendo uma experiência completa, a PokéDex permite aos usuários explorar uma extensa lista de Pokémon. Utilizando uma API oficial dos Pokémon, o site fornece dados atualizados e precisos em tempo real. Com um design responsivo e intuitivo, os usuários podem acessar a PokéDex em qualquer dispositivo, garantindo uma experiência consistente em desktops, tablets e smartphones.Seja para treinadores novatos ou veteranos, a PokéDex é a ferramenta essencial para quem deseja se tornar um mestre Pokémon!"
        app="https://riccettodev.github.io/Pokedex/index.html"
        repo="https://github.com/RiccettoDev/Pokedex"
        technology2={html}
        nameTechnology2="HTML"
        technology3={css}
        nameTechnology3="CSS"
        technology4={javaScript}
        nameTechnology4="JavaScript"
      />
    </div>
  )
}
